<template>
  <LinkdeConviteNew v-if="isShow" :shareInfo="shareInfo"></LinkdeConviteNew>
  <LinkdeConvite v-else :shareInfo="shareInfo"></LinkdeConvite>
</template>

<script>
import { shareIndex } from '@/apis/modules/share.js';
import LinkdeConvite from './LinkdeConvite.vue';
import LinkdeConviteNew from './LinkdeConvite_New.vue';
export default {
  props: {},
  components: {
    LinkdeConvite,
    LinkdeConviteNew
  },
  data() {
    return {
      isShow: false,
      shareInfo: {}
    };
  },
  mounted() {
    shareIndex({
      activity: 0
    }).then(({ data }) => {
      this.shareInfo = data;
      this.isShow = data.user_invite;
    });
  },
  methods: {}
};
</script>
<style scoped></style>
